import React from 'react';

import { jsonTreeTheme } from '../theme.js';

type Props = {
  ricosProps: any;
};

import { JSONTree } from 'react-json-tree';

import { Button } from '../components/Button.js';

export const RicosPropsTab: React.FC<Props> = ({ ricosProps }) => {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          onClick={() => {
            // eslint-disable-next-line no-console
            console.log(ricosProps);
          }}
        >
          Log Props
        </Button>
      </div>
      <JSONTree data={ricosProps} invertTheme={false} theme={jsonTreeTheme} hideRoot />
    </div>
  );
};
